// extracted by mini-css-extract-plugin
export default {"checkbox":"fRH1cuEXZiFGV9DZZte3","checked":"mGbp_QP4YSGLKoMn2D3f fRH1cuEXZiFGV9DZZte3","unchecked":"VosKG3y724Y4NxvCUgoV fRH1cuEXZiFGV9DZZte3"};